import React, { lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SimLoading from './components/SimLoading';
import AppErrorBoundary from './components/AppErrorBoundary';
import { normalizePath, isConsolePath } from './lib/consolePath';

// 학생이 맨 처음 보는 것은 코드 입력 화면(App)이다. 콘솔과 직무 책장은 그 학생이 평생
// 열지 않을 화면인데, 정적으로 import 하면 첫 화면이 그 무게까지 다 받고 나서야 뜬다.
// 경로별로 받는다 — 라우트가 맞은 사람만 그 짐을 진다.
//
// react-router 도 마찬가지다. 쓰는 곳은 src/admin 뿐인데 여기서 <BrowserRouter> 를
// 쓰는 바람에 학생의 첫 번들에 라우터가 통째로 실려 있었다(main.js 원본의 절반).
// 경로를 여기서 한 번만 갈라 주고, 라우터는 콘솔 쪽에서만 받는다.
const ConsoleRoutes = lazy(() => import('./ConsoleRoutes'));
const JobShelf = lazy(() => import('./components/JobShelf'));
const JobLibrary = lazy(() => import('./components/JobLibrary'));

// 개발 환경에서 시뮬레이터 개발 상태 로깅
if (process.env.NODE_ENV === 'development') {
  import('./utils/simulatorRegistry').then(({ devUtils }) => {
    devUtils.logDevProgress();
  });
}

// 콘솔인지는 lib/consolePath 가 정한다 — Firebase 앱(Auth 세션)을 가르는 config.js 와 **같은 판정**이어야
// 콘솔 문서가 콘솔 세션을 쓴다. 여기서 따로 정하면 한쪽만 고쳐져 로그인이 엉뚱한 세션에 붙는다.
function screenFor(rawPath) {
  const path = normalizePath(rawPath);
  if (isConsolePath(path)) return <ConsoleRoutes />;
  // 직무 책장(임시) — 비공개 경로. 콘솔 직무 슬롯이 카탈로그에 오르면 라이선스 판정 자리로 옮긴다.
  //   /job5073      : 직무 책장이 꽂힌 **주제 서고** (학생이 실제로 보게 될 모습)
  //   /job5073/map  : 책 맵 — 어떤 책의 무엇이 아직 비어 있는지 한눈에
  if (path === '/job5073/map') return <JobShelf />;
  if (path === '/job5073') return <JobLibrary />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 맨 바깥 안전망 — 배포 사이에 열려 있던 화면이 옛 조각을 못 받으면 한 번 새로고침한다.
        받는 곳이 없으면 트리가 통째로 내려가 하얀 화면이 됐다(components/AppErrorBoundary). */}
    <AppErrorBoundary>
      <SimLoading label="불러오는 중입니다">
        {screenFor(typeof window !== 'undefined' ? window.location.pathname : '/')}
      </SimLoading>
    </AppErrorBoundary>
  </React.StrictMode>
);

// 성능 측정 (선택적)
// reportWebVitals(console.log);
